/**
 * 在线字体加载工具
 *
 * 使用浏览器原生 FontFace API 按需加载 webfont；
 * 在 SSR 或旧浏览器（不支持 FontFace）下会自动降级，只返回 fontFamily。
 *
 * 使用示例：
 *   import { loadJDZhengHTRegular } from '@jd/jdesign-vue'
 *   const { fontFamily, promise } = loadJDZhengHTRegular()
 *   promise?.then(() => {
 *     // 字体已就绪
 *   })
 *   // <div :style="{ fontFamily }">...</div>
 */

export interface FontLoadResult {
  /** 供 CSS `font-family` 使用的字体名 */
  fontFamily: string
  /** 字体加载完成的 Promise；SSR / 不支持环境下为 undefined */
  promise?: Promise<void>
}

/**
 * 通用在线字体加载器
 * @param fontFamily 字体名
 * @param url 字体资源 URL，支持相对协议 `//...`
 * @param descriptors FontFace descriptors，如 { weight, style }
 */
export function loadOnlineFont(
  fontFamily: string,
  url: string,
  descriptors?: FontFaceDescriptors,
): FontLoadResult {
  // SSR / 不支持 FontFace 的旧浏览器降级
  if (typeof window === 'undefined' || typeof (window as any).FontFace === 'undefined') {
    return { fontFamily }
  }

  const font = new FontFace(fontFamily, `url(${url})`, descriptors)
  return {
    fontFamily,
    promise: font.load().then((loaded) => {
      ;(document as any).fonts?.add(loaded)
    }),
  }
}

/**
 * 加载京东正黑体 EN Regular 在线字体
 */
export function loadJDZhengHTRegular(): FontLoadResult {
  return loadOnlineFont(
    'JDZhengHT-EN',
    '//storage.360buyimg.com/jmt/JDZhengHT-EN-Regular.woff',
  )
}